import React, { useEffect, useState } from "react";
import ProductForm from "./ProductForm";
// import ProductForm from "./productForm";


const EditProduct = () => { 

  return (
     <>
     <ProductForm isEditMode={true}/>
     </>
  );
};

export default EditProduct;
